import React, { useRef } from 'react'
import Text from '../../atoms/Text'
import Button from '../../atoms/GoodFlipButton'
import Arrow from '../../atoms/Arrow'
import ItemCard from './ItemCard'
import { useSelector } from 'react-redux'
import CancelIcon from '../../../assets/icons/cancel_icon.svg'
import SlideUpPanel from '../../atoms/SlideUpPanel'
import FoodScoreInfo from './FoodScoreInfo'
import MobileLayout from '../../MobileLayout'
import PotassiumSummaryCard from './PotassiumSummaryCard'

const FoodBreakdown = ({
  onClickItem = (item = null) => {},
  onClickViewMore = () => {},
}) => {
  const scoreInfoSlide = useRef(null)
  const { pndsScore } = useSelector((s) => s.foodScan)

  const scoreInfo = () => {
    scoreInfoSlide.current?.show()
  }

  const hideScoreInfo = () => {
    scoreInfoSlide.current?.hide()
  }

  return (
    <>
      <div className="py-2 px-4 flex flex-col gap-4">
        <Text
          tag={'p'}
          variant={'headline'}
          size={'large'}
          className={'text-text-primary'}
        >
          Your Food Breakdown
        </Text>
        <Text
          tag={'p'}
          variant={'body'}
          size={'medium'}
          className={'text-text-quartenary'}
        >
          See how each ingredient contributes to your health when consumed
          individually and how they align with kidney care recommendations
        </Text>
        {pndsScore?.data?.potassium_summary && (
          <PotassiumSummaryCard
            grade={pndsScore?.data?.meal_details?.grade}
            title="Potassium Friendliness"
            summary={pndsScore?.data?.potassium_summary}
            className="mb-2"
          />
        )}
        {!!pndsScore?.data?.food_details?.[0] && (
          <ItemCard
            grade={pndsScore?.data?.food_details?.[0].grade}
            isClickable
            onClick={() => onClickItem(pndsScore?.data?.food_details?.[0])}
            showRecommendation
            title={pndsScore?.data?.food_details?.[0].food_details.food_item}
            foodDetails={pndsScore?.data?.food_details?.[0].food_details}
            keyNutrients={pndsScore?.data?.food_details?.[0].key_nutrients}
          />
        )}
        {!!pndsScore?.data?.food_details?.[1] && (
          <ItemCard
            grade={pndsScore?.data?.food_details?.[1].grade}
            isClickable
            onClick={() => onClickItem(pndsScore?.data?.food_details?.[1])}
            showRecommendation
            title={pndsScore?.data?.food_details?.[1].food_details.food_item}
            foodDetails={pndsScore?.data?.food_details?.[1].food_details}
            keyNutrients={pndsScore?.data?.food_details?.[1].key_nutrients}
          />
        )}
        {(pndsScore?.data?.food_details ?? []).slice(2).length > 0 && (
          <Button
            type={'goodflip_secondary'}
            title={`View ${(pndsScore?.data?.food_details ?? []).slice(2).length} More`}
            onClick={onClickViewMore}
            rightIcon={null}
            leftIcon={null}
            className="w-1/2 self-center"
          />
        )}
        <div
          className={`p-4 bg-[#FFF7ED] border border-yellow-700 rounded-xl mt-2`}
        >
          <Text
            tag={'p'}
            variant={'label'}
            size={'medium'}
            bold={'true'}
            className={`text-yellow-950 mb-2`}
          >
            Disclaimer
          </Text>
          <Text
            tag={'p'}
            variant={'body'}
            size={'medium'}
            className={`text-yellow-700`}
          >
            The nutritional information provided through the food scanner is
            intended for educational purposes only. Patients should not make
            dietary changes based solely on this information and are advised to
            follow the guidance of their treating clinician.
          </Text>
        </div>
        <div className="w-full flex flex-col items-center gap-0.5 py-4">
          <Text
            tag={'p'}
            variant={'body'}
            size={'large'}
            className={'text-text-primary'}
          >
            Want to know more about our grading system?
          </Text>
          <button
            className="flex flex-row items-center gap-1.5"
            onClick={scoreInfo}
          >
            <Text
              tag={'p'}
              variant={'label'}
              size={'large'}
              bold={'true'}
              className={'text-[#199EA5] underline'}
            >
              See How It Works
            </Text>
            <Arrow direction="right" color="#199EA5" />
          </button>
        </div>
      </div>

      {/* Slide up Pannel */}
      <SlideUpPanel
        ref={scoreInfoSlide}
        header={
          <div className="flex justify-end items-center p-3">
            <button onClick={hideScoreInfo}>
              <img src={CancelIcon} />
            </button>
          </div>
        }
      >
        <FoodScoreInfo />
      </SlideUpPanel>
    </>
  )
}

export default FoodBreakdown
